export const getBaseUrlFromEnv = () => {
    return process.env.REACT_APP_BASE_DOMAIN;
};
